import React, { useState, useEffect } from "react";

export default function ProductList2(productListData) {
  const data = []
  const [datax, setData] = useState(data);
  const [checkNewProjectDate, setCheckNewProjectDate] = useState("");

  useEffect(() => {
    //console.log("productListData", productListData.productListData)
    setData(productListData.productListData);
    let todayObject = new Date();
    setCheckNewProjectDate(todayObject.toISOString().split('T')[0]);

  }, [productListData.productListData]);

  function convertToExpiryDate(creationDate) {
    let todayObject = new Date(creationDate);
    var checkDateObject = todayObject.setDate(todayObject.getDate() + 14);
    var result = new Date(checkDateObject);
    return result.toISOString().split('T')[0];
  }
  return (
    <div className="bg-white">
      <div className="py-6 lg:max-w-7xl lg:mx-auto lg:px-8">
        <div className="relative">
          <div className="relative w-full pb-6 -mb-6">
            <div
              className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-3 xl:gap-x-8"
            >
              {datax.map((product, index) => (
                <div key={product.id} className="inline-flex flex-col text-center lg:w-auto mt-8">
                  <div className="group relative cursor-pointer" onClick={() => {
                    window.location.href = "/ProductDetail?projectId=" + product.projectId;
                  }}>
                    <div className="w-full bg-gray-200 rounded-md overflow-hidden  lg:h-64 h-52">
                      <img
                        src={product.projectCoverImg}
                        alt=""
                        className="w-full h-full object-center object-fill group-hover:opacity-75"
                      />
                    </div>
                    <div style={{ position: "absolute", marginTop: "-15px", background: "red", color: "white", borderRadius: "3px", paddingLeft: "5px", paddingRight: "5px", marginLeft: "3px", fontWeight: "bold", fontStyle: "italic", right: "0px",fontSize:"13px"  }}>
                      <p>
                        項目編號：{product.id}
                      </p>
                    </div>
                    {convertToExpiryDate(product.creationTime) < checkNewProjectDate ?
                      ""
                      :
                      <div style={{ position: "absolute", marginTop: "-15px", background: "red", color: "white", borderRadius: "3px", width: "100px", left: "0px", marginLeft: "0px", fontWeight: "bold", fontStyle: "italic", fontSize:"13px" }}>
                        <p>
                          新案例
                        </p>
                      </div>
                    }
                    <div className="mt-6">
                      <p className="text-sm text-gray-500">
                        {product.projectBuildingStyle == "Y2" ? "Y2型 (公屋/居屋)" : ""}
                        {product.projectBuildingStyle == "Y3" ? "Y3型 (公屋/居屋)" : ""}
                        {product.projectBuildingStyle == "Y4" ? "Y4型 (公屋/居屋)" : ""}
                        {product.projectBuildingStyle == "NCB" ? "新十字型 (居屋)" : ""}
                        {product.projectBuildingStyle == "CB" ? "康和式 (居屋)" : ""}
                        {product.projectBuildingStyle == "HR" ? "和諧式 (居屋)" : ""}
                        {product.projectBuildingStyle == "LB" ? "相連長型 (公屋)" : ""}
                        {product.projectBuildingStyle == "OS" ? "長型或新長型 (公屋)" : ""}
                        {product.projectBuildingStyle == "SORDHB" ? "單或雙工字型 (公屋)" : ""}
                        {product.projectBuildingStyle == "TT" ? "雙塔式 (公屋)" : ""}
                        {product.projectBuildingStyle == "NSBD" ? "非標準型 (公屋)" : ""}
                        {product.projectBuildingStyle == "Others" ? "其他" : ""}
                      </p>
                      <h3 className="mt-1 font-semibold text-gray-900">
                        <span className="absolute inset-0" />
                        {product.projectHouseName}
                      </h3>
                    </div>
                    <h4 className="sr-only">風格</h4>
                    {/* <ul className="mt-auto pt-6 flex items-center justify-center space-x-3">
                      <li
                        key={index + "c1"}
                        className="rounded-full border border-black border-opacity-10 pl-2 pr-2 bg-cyan-900"
                      >
                        <span className="text-white">
                          {product.projectBuildingStyle === 'Japan' ? "日式" : ""}
                          {product.projectBuildingStyle === 'China' ? "中式" : ""}
                          {product.projectBuildingStyle === 'Europe' ? "歐式" : ""}
                          {product.projectBuildingStyle === 'MuJi' ? "無印風" : ""}
                          {product.projectBuildingStyle === 'Modern' ? "現代風" : ""}
                        </span>
                      </li>
                      <li
                        key={index + "c2"}
                        className="rounded-full border border-black border-opacity-10 pl-2 pr-2 bg-cyan-700"
                      >
                        <span className="text-white">
                          {product.projectArea === 'HK' ? "香港" : ""}
                          {product.projectArea === 'NT' ? "新界" : ""}
                          {product.projectArea === 'KL' ? "九龍" : ""}
                        </span>
                      </li>
                      {
                        product.hasFeatured === 1 ?
                          <li
                            className="rounded-full border border-black border-opacity-10 pl-2 pr-2 bg-cyan-600"
                          >
                            <span className="text-white">精選</span>
                          </li>
                          : ""
                      }
                    </ul> */}
                  </div>

                </div>
              ))}
            </div>


          </div>
        </div>
      </div>
    </div>
  )
}
